import React, { useEffect } from "react";

const rawText = `Podmínky používání Věrnost Business pro partnery

Verze: 1.0
Účinné od: 20.08.2026

1. Provozovatel a působnost

1.1. Provozovatelem platformy Věrnost Business a aplikace Věrnost je Ivan Kuznetsov, IČO 19911173, místo podnikání: Nové sady 988/2, 602 00 Staré Brno, e-mail: podpora.vernostapp@gmail.com (dále jen „Provozovatel“ nebo „Věrnost“).

1.2. Tyto podmínky upravují používání Věrnost Business podnikateli a jinými schválenými subjekty, které prostřednictvím platformy provozují věrnostní program nebo jinou nabídku pro zákazníky (dále jen „Partner“).

1.3. Věrnost Business je nástroj pro správu digitálního věrnostního programu. Platforma může zahrnovat zejména Přehled, QR, Zaměstnance, Věrnostní program, vlastní design kartičky a razítek, Kupóny, Historii aktivit a úpravu profilu podniku.

2. Registrace a schválení Partnera

2.1. Partner při registraci uvede požadované údaje o sobě a podniku pravdivě, úplně a aktuálně.

2.2. Registrace sama o sobě nemusí znamenat automatické zveřejnění podniku v aplikaci Věrnost. Provozovatel může profil před zveřejněním ověřit, požádat o doplnění informací, schválit, dočasně pozastavit nebo odmítnout, pokud pro to existuje legitimní důvod.

2.3. Partner odpovídá za to, že je oprávněn podnikat a nabízet zboží, služby, slevy, odměny a další plnění uvedená ve svém profilu.

3. Účet Partnera

3.1. Partner odpovídá za zabezpečení svého účtu a přístupových údajů.

3.2. Partner nesmí umožnit neoprávněné osobě přístup k administraci Věrnost Business.

3.3. Pokud Partner zjistí nebo důvodně předpokládá zneužití účtu, oznámí ovu skutečnost bez zbytečného odkladu Provozovateli.

4. Profil podniku

4.1. Partner odpovídá za správnost a aktuálnost údajů zveřejněných v aplikaci, zejména názvu, adresy, kategorie, kontaktních údajů, otevírací doby, fotografií a popisu.

4.2. Partner je povinen bez zbytečného odkladu aktualizovat informace, které se změnily a mohou ovlivnit zákazníky.

4.3. Věrnost může požadovat opravu zjevně nepravdivých, klamavých, neaktuálních nebo protiprávních údajů.

5. Věrnostní program

5.1. Partner prostřednictvím Věrnost Business nastavuje pravidla svého věrnostního programu v rámci funkcí dostupných v platformě. Partner plně odpovídá za nastavení a skutečné poskytnutí odměn.

5.2. Partner může zejména určit: - počet razítek potřebných k získání odměny; - obsah a hodnotu odměny; - aktivní či neaktivní stav programu; - vzhled digitální kartičky; - vlastní design nebo ikonu razítka, pokud je funkce dostupná v jeho tarifu.

5.3. Partner odpovídá za srozumitelnost podmínek programu a za skutečné poskytnutí odměny, kterou prostřednictvím Věrnost slíbil.

5.4. Partner může pravidla a odměny svého věrnostního programu měnit. Pokud zákazník ještě nedosáhl požadovaného počtu razítek a nárok na odměnu mu ještě nevznikl, vztahují se na něj aktuální pravidla a aktuální odměna programu. Pokud Partner změní pravidla nebo odměnu věrnostního programu před tím, než zákazník splní podmínky pro získání odměny, vztahují se na další průběh programu aktuálně platná pravidla. Již řádně vzniklý nárok na odměnu však následná změna programu sama o sobě neruší.

5.5. Pokud zákazník již splnil podmínky a získal konkrétní odměnu, následná změna programu nesmí zpětně zrušit již vzniklý nárok. Partner nesmí svévolně manipulovat s již získaným zákaznickým postupem způsobem, který by byl klamavý nebo v rozporu s právními předpisy.

5.6. Partner může věrnostní program deaktivovat nebo ukončit. Po deaktivaci se do programu nemají připojovat noví zákazníci a nemají vznikat nové účasti podle ukončeného programu. Již vzniklé nároky zákazníků musí být přiměřeně zohledněny. Partner nesmí deaktivaci nebo ukončení programu používat k obcházení povinnosti poskytnout již řádně získanou odměnu. Technické odstranění programu může být omezeno, pokud je potřeba zachovat existující zákaznické nároky nebo související evidenci. Partner nesmí aktivní věrnostní program s existujícími účastníky jednoduše okamžitě odstranit způsobem, který by bez dalšího zrušil již vzniklé nároky zákazníků.

6. QR, razítka a Premium návštěvy

6.1. Partner a jeho oprávnění zaměstnanci mohou prostřednictvím QR systému ověřovat zákazníky a připisovat razítka v rámci věrnostního programu. Premium návštěvy se evidují samostatně podle pravidel služby Věrnost.

6.2. Pro jednoho uživatele může být u stejného partnerského podniku započítána nejvýše jedna Premium návštěva za jeden kalendářní den.

6.3. Partner nesmí vytvářet fiktivní razítka nebo návštěvy, zneužívat zákaznické účty, manipulovat s odměnami ani obcházet technická omezení systému.

6.4. Věrnost může zjevně chybné, duplicitní nebo podvodné záznamy po přiměřeném ověření opravit nebo odstranit.

7. Zaměstnanci

7.1. Partner může ve Věrnost Business vytvářet zaměstnance. Pro zaměstnance se používá zejména jméno a PIN pro přístup zaměstnance.

7.2. Partner plně odpovídá za osoby, kterým přístup vytvoří, za bezpečné používání zaměstnaneckých PINů a za včasnou deaktivaci zaměstnance po skončení spolupráce nebo při bezpečnostním riziku.

7.3. Partner je povinen zaměstnance přiměřeně poučit o správném používání QR systému, připisování razítek, uplatňování odměn a kupónů.

7.4. Historie aktivit zaměstnanců může evidovat jejich činnosti související například s razítky, návštěvami a kupóny. Tyto záznamy mohou být uchovávány a zobrazovány Partnerovi pro provozní, bezpečnostní a kontrolní účely v souladu se Zásadami ochrany osobních údajů.

8. Odměny

8.1. Věrnost technicky eviduje postup zákazníka a případný nárok na odměnu.

8.2. Samotnou odměnu poskytuje Partner. Věrnost není prodávajícím ani poskytovatelem zboží nebo služby, která tvoří odměnu Partnera.

8.3. Partner odpovídá za to, že odměna odpovídá popisu v Aplikaci a že její poskytnutí je v souladu s právními předpisy.

9. Premium návštěvy a kupóny

9.1. Věrnost umožňuje v rámci Premium funkcí evidovat Premium návštěvy a využívat prémiové kupóny podle aktuálních pravidel služby.

9.2. Partner s odpovídajícím tarifem Věrnost Business může vytvářet a spravovat kupóny. Partner plně odpovídá za obsah nabídky, podmínky kupónu, dobu platnosti, případná omezení a skutečné poskytnutí slíbeného plnění.

9.3. Pokud Partner kupón deaktivuje nebo ukončí jeho další nabídku, kupón již nemá být nově dostupný dalším uživatelům. Uživatel, který kupón řádně získal před jeho deaktivací, jej však může nadále využít podle původních podmínek a doby platnosti. Deaktivace kupónu nesmí zpětně odebrat již řádně získaný platný kupón.

9.4. Partner je povinen takový platný, již získaný kupón přijmout a poskytnout slíbené plnění, pokud je řádně uplatněn v souladu s jeho původními podmínkami.

10. Obsah Partnera a licence

10.1. Partner může do Věrnost nahrávat zejména logo, fotografie, texty, vzhled kartičky, grafiku a vlastní razítko (dále jen „Obsah Partnera“).

10.2. Partner prohlašuje, že má k Obsahu Partnera potřebná práva a jeho použitím neporušuje autorská práva, ochranné známky, práva na ochranu osobnosti ani jiná práva třetích osob.

10.3. Partner uděluje Provozovateli po dobu spolupráce nevýhradní, bezúplatné oprávnění Obsah Partnera technicky ukládat, rozmnožovat, zobrazovat a přiměřeně upravovat v rozsahu nezbytném pro provoz, prezentaci a propagaci Věrnost a konkrétního partnerského podniku.

10.4. Provozovatel není oprávněn bez dalšího prodávat Obsah Partnera jako samostatný obsah třetím osobám.

11. Hodnocení a recenze

11.1. Aplikace může umožňovat uživatelům zveřejňovat hodnocení nebo recenze podniku.

11.2. Partner může prostřednictvím dostupné funkce veřejně odpovědět na hodnocení nebo recenzi uživatele. Partner odpovídá za obsah své odpovědi a je povinen dodržovat právní předpisy a pravidla platformy.

11.3. Negativní hodnocení samo o sobě není důvodem k odstranění. Věrnost může zasáhnout zejména v případě zjevného porušení pravidel platformy nebo právních předpisů.

11.4. Partner nesmí uživatele nutit k pozitivnímu hodnocení, vytvářet falešné recenze nebo jinak manipulovat systém hodnocení.

12. Věrnost Business – Free a Premium

12.1. Věrnost Business nabízí bezplatné funkce (tarif Free) a placený tarif Premium. Rozsah jednotlivých tarifů se může v budoucnu měnit, přičemž aktuální nabídka zobrazená v rozhraní platformy Věrnost Business má vždy přednost.

12.2. Bezplatný tarif Free aktuálně zahrnuje základní funkce pro provoz věrnostního programu, zejména Přehled, QR systém, sekci Zaměstnanci, základní správu věrnostního programu, Historii aktivit a správu profilu podniku.

12.3. Placený tarif Věrnost Business Premium aktuálně zpřístupňuje zejména vizuální customizaci věrnostní kartičky, vlastní design / vzhled razítek a možnost vytvářet a spravovat kupóny.

12.4. Přesný rozsah placeného tarifu, jeho cena, fakturační období a způsob platby jsou Partnerovi přehledně zobrazeny před objednáním.

13. Osobní údaje a zákaznická data

13.1. Věrnost Business aktuálně neposkytuje Partnerovi samostatný seznam nebo databázi všech zákazníků Věrnost, kterou by mohl libovolně procházet. Údaje konkrétního zákazníka mohou být Partnerovi zpřístupněny pouze v rozsahu potřebném pro konkrétní funkci platformy, zejména při interakci prostřednictvím QR systému a při správě věrnostního programu daného zákazníka. Partner může v tomto kontextu získat pouze údaje zpřístupněné danou funkcí.

13.2. E-mailová adresa zákazníka není Partnerovi prostřednictvím této funkce zpřístupněna. Partner zároveň nemá přístup k aktivitě zákazníka u jiných partnerských podniků.

13.3. Partner smí údaje zpřístupněné prostřednictvím Věrnost používat pouze v rozsahu odpovídajícímu funkci platformy a platným právním předpisům. Partner nesmí údaje zákazníků získané prostřednictvím Věrnost exportovat, kopírovat nebo používat pro vlastní marketing, pokud pro takové použití nemá samostatný platný právní titul.

13.4. Role Provozovatele a Partnera při zpracování osobních údajů se posuzují podle skutečného účelu a prostředků zpracování. Podrobnosti stanoví Zásady ochrany osobních údajů a případná samostatná ujednání o zpracování údajů, pokud jsou podle konkrétního zpracování potřebná.

14. Zakázané používání

Partner nesmí zejména: - používat Věrnost k podvodnému nebo protiprávnímu jednání; - nabízet nelegální zboží, služby nebo odměny; - záměrně neposkytovat platné slíbené odměny; - manipulovat návštěvy, razítka, kupóny nebo hodnocení; - neoprávněně získávat údaje uživatelů; - narušovat bezpečnost nebo dostupnost platformy; - vydávat se za jiný podnik nebo osobu.

15. Dostupnost platformy

15.1. Věrnost usiluje o řádný provoz platformy, negarantuje však nepřetržitou dostupnost bez výpadků.

15.2. Služba může být dočasně omezena zejména z důvodu údržby, aktualizace, bezpečnostního incidentu, výpadku infrastruktury nebo zásahu třetí strany.

15.3. Provozovatel může platformu rozvéjet a měnit. U placených funkcí bude při významných změnách postupovat v souladu s uzavřenou smlouvou a právními předpisy.

16. Odpovědnost

16.1. Partner odpovídá vůči zákazníkům za své zboží, služby, věrnostní programy, odměny, kupóny, informace a jednání svých pracovníků.

16.2. Věrnost poskytuje digitální platformu a není stranou kupní nebo jiné spotřebitelské smlouvy uzavírané mezi Partnerem a zákazníkem, pokud není u konkrétní služby výslovně uvedeno jinak.

16.3. Každá strana odpovídá za škodu a jiné následky porušení svých povinností v rozsahu stanoveném právními předpisy.

17. Pozastavení a ukončení Partnera

17.1. Věrnost může profil nebo přístup Partnera přiměřeně omezit nebo pozastavit zejména při: - podezření na podvod nebo závažné zneužití; - opakovaném neposkytování slíbených odměn; - protiprávním obsahu; - bezpečnostním riziku; - závažném nebo opakovaném porušování těchto podmínek.

17.2. Pokud to povaha situace dovoluje, může Věrnost Partnera předem vyzvat k nápravě.

17.3. Partner může spolupráci ukončit postupem dostupným v platformě nebo kontaktováním podpory.

17.4. Partner může věrnostní program deaktivovat nebo ukončit. Po deaktivaci se do programu nemají připojovat noví zákazníci a nemají vznikat nové účasti podle ukončeného programu. Již vzniklé nároky zákazníků musí být přiměřeně zohledněny. Partner nesmí deaktivaci nebo ukončení programu používat k obcházení povinnosti poskytnout již řádně získanou odměnu a nesmí aktivní věrnostní program s existujícími účastníky jednoduše okamžitě odstranit způsobem, který by bez dalšího zrušil již vzniklé nároky zákazníků. Technické odstranění programu může být omezeno, pokud je potřeba zachovat existující zákaznické nároky nebo související evidenci.

18. Změny podmínek

18.1. Provozovatel může tyto podmínky přiměřeně měnit zejména v návaznosti na změny platformy, obchodního modelu nebo právních předpisů.

18.2. Aktuální znění bude zveřejněno s datem účinnosti. U významných změn může být Partner informován také prostřednictvím Věrnost Business nebo e-mailem.

19. Rozhodné právo a řešení sporů

19.1. Tyto podmínky a vztah mezi Provozovatelem a Partnerem se řídí právem České republiky.

19.2. Strany se zavazují nejprve usilovat o smírné řešení sporu.

19.3. Není-li spor vyřešen smírně, bude řešen příslušným soudem podle obecně závazných právních předpisů. Tento dokument nezavádí rozhodčí doložku.

20. Závěrečná ustanovení

20.1. Pokud je některé ustanovení neplatné nebo neúčinné, ostatní ustanovení tím nejsou dotčena.

20.2. Kontaktní e-mail: podpora.vernostapp@gmail.com.`;

export default function PodminkyProPartnery({ renderHeader, renderFooter }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Podmínky používání Věrnost Business pro partnery";
  }, []);

  const lines = rawText.split("\n").map(line => line.trim()).filter(line => line.length > 0);

  return (
    <div className="min-h-screen bg-[#FDFDFD] text-[#111111] font-sans antialiased selection:bg-[#FF5A00]/10 selection:text-[#FF5A00]">
      {renderHeader()}

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-left">
        {/* Document Title Header */}
        <div className="border-b-2 border-[#FF5A00]/20 pb-8 mb-10">
          <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-neutral-900 leading-tight mb-4">
            Podmínky používání Věrnost Business pro partnery
          </h1>
          <div className="flex flex-wrap gap-4 sm:gap-6 text-sm font-bold text-neutral-500">
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Verze: 1.0</span>
            <span className="bg-neutral-100 px-3.5 py-1.5 rounded-lg border border-neutral-200">Účinné od: 20.08.2026</span>
          </div>
        </div>

        {/* Legal Text Content */}
        <div className="space-y-6">
          {lines.slice(3).map((line, idx) => {
            // Check for main headings and bullet lists
            const isMainHeading = /^\d+\.\s+[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]/.test(line);
            
            if (isMainHeading) {
              return (
                <h2 
                  key={idx} 
                  className="font-heading font-extrabold text-xl sm:text-2xl text-neutral-900 mt-10 mb-4 pt-4 border-b border-neutral-100 pb-2"
                >
                  {line}
                </h2>
              );
            }

            // Bullet lists
            if (line.includes(" - ")) {
              const parts = line.split(" - ");
              return (
                <div key={idx} className="mb-4">
                  <p className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-2">{parts[0]}</p>
                  <div className="space-y-1">
                    {parts.slice(1).map((part, pIdx) => (
                      <div key={pIdx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                        <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                        <span>{part.trim()}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            const isBullet = line.startsWith("-");
            if (isBullet) {
              return (
                <div key={idx} className="pl-6 flex items-start space-x-2 text-base text-neutral-700 leading-relaxed">
                  <span className="text-[#FF5A00] mt-1 shrink-0">•</span>
                  <span>{line.substring(1).trim()}</span>
                </div>
              );
            }

            return (
              <p 
                key={idx} 
                className="text-base sm:text-lg text-neutral-700 leading-relaxed mb-4"
              >
                {line}
              </p>
            );
          })}
        </div>
      </main>

      {renderFooter()}
    </div>
  );
}
